import FlipbookViewer from "../components/FlipbookViewer";

export default function SpaCovers() {
  return (
    <div>
      {/* Hero */}
      <section className="relative bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white">SPA COVERS</h1>
        </div>
      </section>

      {/* Brochure Prompt */}
      <section className="py-10 md:py-12 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
          <p className="text-sm md:text-base text-gray-700">Check out the brochure below!</p>
        </div>
      </section>

      {/* Brochure Section */}
      <section className="py-10 md:py-14 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-8">
          <FlipbookViewer
            title="Spa Covers Brochure"
                      downloadUrl="/images/Merlin-SpaCovers-2024.pdf"
          />
        </div>
      </section>
    </div>
  );
}